'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _registerFetchInterceptor = require('./registerFetchInterceptor');

var _registerFetchInterceptor2 = _interopRequireDefault(_registerFetchInterceptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BatteryFriendlyTimer = function () {
    function BatteryFriendlyTimer(win) {
        _classCallCheck(this, BatteryFriendlyTimer);

        this.win = win;
        this.isFetching = false;
        this.latestId = 0;
        this.timeouts = {};
        this.forceTimeouts = {};
        this.intervals = {};
        this.forceIntervals = {};
        (0, _registerFetchInterceptor2.default)(this.fetchHappens.bind(this), this.win);
    }

    _createClass(BatteryFriendlyTimer, [{
        key: 'fetchHappens',
        value: function fetchHappens() {
            var _this = this;

            if (this.isFetching) {
                return;
            }
            this.isFetching = true;
            var now = Date.now();
            Object.keys(this.timeouts).forEach(function (timeoutKey) {
                var timeout = _this.timeouts[timeoutKey];
                if (now - timeout.from >= timeout.tryDelay) {
                    timeout.callback();
                    _this.clearTimeout(timeoutKey);
                }
            });
            Object.keys(this.intervals).forEach(function (intervalKey) {
                var interval = _this.intervals[intervalKey];
                if (now - interval.latest >= interval.tryDelay) {
                    interval.callback();
                    interval.latest = now - (now - interval.from) % interval.tryDelay;
                }
            });
            this.isFetching = false;
        }
    }, {
        key: 'setTimeout',
        value: function setTimeout(callback, tryDelay, forceDelay) {
            var latestId = ++this.latestId;
            this.timeouts[latestId] = { from: Date.now(), callback: callback, tryDelay: tryDelay };
            this.forceTimeouts[latestId] = this.win.setTimeout(callback, forceDelay);
            return latestId;
        }
    }, {
        key: 'clearTimeout',
        value: function clearTimeout(id) {
            this.win.clearTimeout(this.forceTimeouts[id]);
            delete this.timeouts[id];
            delete this.forceTimeouts[id];
        }
    }, {
        key: 'setInterval',
        value: function setInterval(callback, tryDelay, forceDelay) {
            var latestId = ++this.latestId;
            var now = Date.now();
            var interval = { from: now, latest: now, callback: callback, tryDelay: tryDelay, forceDelay: forceDelay };
            this.intervals[latestId] = interval;
            this.forceIntervals[latestId] = this.win.setInterval(function () {
                now = Date.now();
                if (now - interval.latest >= interval.forceDelay) {
                    callback();
                    interval.latest = now;
                }
            }, forceDelay);
            return latestId;
        }
    }, {
        key: 'clearInterval',
        value: function clearInterval(id) {
            this.win.clearInterval(this.forceIntervals[id]);
            delete this.intervals[id];
            delete this.forceIntervals[id];
        }
    }]);

    return BatteryFriendlyTimer;
}();

exports.default = BatteryFriendlyTimer;
module.exports = exports['default'];